/* eslint-disable no-undef */
const _VERSION = BUILD_VERSION;
const _ENV = ENV;
const _PGW_SRC = document.currentScript.src;
const _PGW_ORIGIN = _PGW_SRC.substring(0, _PGW_SRC.lastIndexOf('/'));
const _THREE_URL = `${_PGW_ORIGIN}/cld-3d-viewer.js`;
const _THREE_DRACO_URL = 'https://www.gstatic.com/draco/v1/decoders/';
const _ANALYTICS_URL = 'https://analytics-api-s.cloudinary.com';
const _USE_ANALYTICS = USE_ANALYTICS;
const _CLD_VIDEO_PLAYER_JS =
  'https://unpkg.com/cloudinary-video-player@{{version}}/dist/cld-video-player.min.js';
const _CLD_VIDEO_PLAYER_CSS =
  'https://unpkg.com/cloudinary-video-player@{{version}}/dist/cld-video-player.min.css';

export { _VERSION as VERSION };

export { _ENV as ENV };

export { _THREE_DRACO_URL as THREE_DRACO_URL };

export { _THREE_URL as THREE_URL };

export { _ANALYTICS_URL as ANALYTICS_URL };

export { _USE_ANALYTICS as USE_ANALYTICS };

export { _CLD_VIDEO_PLAYER_JS as CLD_VIDEO_PLAYER_JS };

export { _CLD_VIDEO_PLAYER_CSS as CLD_VIDEO_PLAYER_CSS };
